import { ActivityGroupProps } from '~/bootcamp/Activities/types/activities.types'

import MultiAddition from './MultiAddition/MultiAddition'
import MultiDivision from './MultiDivision/MultiDivision'
import OrderPicker from './Pemdas/OrderPicker'
import PEMDAS from './Pemdas/Pemdas'
import PlusMinus from './PlusMinus/PlusMinus'

const Bootcamp1Activities = ({ activityName, ...props }: ActivityGroupProps): React.ReactElement => {
  switch (activityName) {
    case 'PlusMinus':
      return <PlusMinus {...props} />
    case 'MultiDivision':
      return <MultiDivision {...props} />
    case 'MultiAddition':
      return <MultiAddition {...props} />
    case 'OrderPicker':
      return <OrderPicker {...props} />
    case 'PEMDAS':
      return <PEMDAS {...props} />
    default:
      return <></>
  }
}

export default Bootcamp1Activities
